import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Stack, ThemeProvider, useTheme } from "@mui/material";
import AppHeader from "../components/AppHeader";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { useAuth } from "../store/auth/hooks";

export default function AppPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useAuth();
  const theme = useTheme();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login");
    } else {
      if (location.pathname === "/app") navigate("/app/cases");
    }
  }, [isAuthenticated, location, navigate]);

  return (
    <ThemeProvider theme={theme}>
      <AppHeader />
      <Stack height={1}>
        <Outlet />
      </Stack>
    </ThemeProvider>
  );
}
